import { Box, Paper, Skeleton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import { SPACING } from '@common/theme/spacing'

export default function QueriesTableSkeleton() {
  return (
    <Box component="section">
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
        <Skeleton variant="rectangular" width={120} height={36} sx={{ mr: 2 }} />
        <Skeleton variant="rectangular" width={220} height={36} />
      </Box>
      <Paper sx={{ p: SPACING.paperInnerPadding }}>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell padding="checkbox">
                  <Skeleton variant="rectangular" width={24} height={24} />
                </TableCell>
                {Array.from({ length: 8 }).map((_, index) => (
                  <TableCell key={index}>
                    <Skeleton variant="text" width={100} />
                  </TableCell>
                ))}
                <TableCell>
                  <Skeleton variant="text" width={40} />
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {Array.from({ length: 5 }).map((_, rowIndex) => (
                <TableRow key={rowIndex}>
                  <TableCell padding="checkbox">
                    <Skeleton variant="rectangular" width={24} height={24} />
                  </TableCell>
                  {Array.from({ length: 8 }).map((_, cellIndex) => (
                    <TableCell key={cellIndex}>
                      <Skeleton variant="text" width={cellIndex === 5 ? 80 : 100} />
                    </TableCell>
                  ))}
                  <TableCell align="right">
                    <Skeleton variant="circular" width={24} height={24} />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Box>
  )
}
